import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { CustomTheme } from '../../appTemplates/MUIProviderTemplate/MUIProviderTemplateInterfaces';
import { SERVER_ERRORS } from '../../constants/backendResponse';
import { serverErrorMessageSelector } from '../../store/selectors/appSelectors';
import styles from './ServerError.module.scss';
import { getTranslation } from '../../utils/functions';

const useServerErrorStyles = makeStyles((theme: CustomTheme) => {
  return {
    button: {
      color: theme.palette.secondary.main,
      textTransform: 'uppercase',
      marginTop: '30px',
    },
    errorMessage: {
      textAlign: 'center',
      lineHeight: 1.4,
      fontSize: 18,
      fontWeight: 500,
    },
  };
});

const ServerError: React.FC = () => {
  const serverErrorStyles = useServerErrorStyles();
  const serverErrorMessage = useSelector(serverErrorMessageSelector);

  const getErrorMessage = (): string | undefined => {
    if (serverErrorMessage === SERVER_ERRORS.NOT_FOUND) {
      return 'Something went wrong, make sure that your link is valid';
    }

    if (serverErrorMessage === SERVER_ERRORS.VALIDATION_ERROR) {
      return 'Something went wrong, make sure that your link is valid';
    }

    if (serverErrorMessage === SERVER_ERRORS.SERVER_UNAVAILABLE) {
      return 'Server unavailable';
    }

    return undefined;
  };

  const renderedExpired = (): JSX.Element => {
    return (
      <>
        <div className={styles.imgWrapper}>
          <img src="assets/entrance-error.svg" alt="Expired" className={styles.expiredImg} />
        </div>
        <div className="hid-spacing__mt-06">
          <p className={serverErrorStyles.errorMessage}>
            {getTranslation('REGISTRATION_LINK_EXPIRED1')}
          </p>
          <p className={serverErrorStyles.errorMessage}>
            {getTranslation('REGISTRATION_LINK_EXPIRED2')}
          </p>
        </div>
      </>
    );
  };

  const reloadPage = (): void => {
    window.location.reload();
  };

  return (
    <>
      {
        // serverErrorMessage === SERVER_ERRORS.BAD_REQUEST ? renderedExpired()
        // :
        <>
          <p className={serverErrorStyles.errorMessage}>{getErrorMessage()}</p>

          <Button
            className={serverErrorStyles.button}
            onClick={() => {
              reloadPage();
            }}
          >
            {/* {getTranslation('RELOAD_PAGE')} */}
            Reload Page
          </Button>
        </>
      }
    </>
  );
};

export default ServerError;
